var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('img',{staticClass:"alt-pointer alt-image-in-grid",attrs:{"loading":"lazy","src":_vm.image},on:{"click":_vm.buttonClick}}):_c('ImagePlaceholderSvg',{on:{"buttonClick":_vm.buttonClick}})}
var staticRenderFns = []

export { render, staticRenderFns }